<template>
<div>
    <form action="do_information" method="post" id="form1">
	<ul class="apply ovw soak soak_1 info">
		<li class="pad pad_a ovw">
			<span>头像</span>
			<div class="fr">
				<span class="font_c">
					<img src="http://wx.qlogo.cn/mmopen/AHicXW1gxYzpL32icZ14LQ8hyVToF6ZQDCcTH9AcxgUbqUxLfGwxNEQD8mrnfkLffpibEj21qCiatPZ1MCceYzA4WcgncXv0dHES/0" alt="">
				</span>
				<img src="/static/rt.png" alt="">
			</div>
		</li>

		<li class="pad">
			<span>姓名</span>
			<div class="fr">
				<input class="font_c ipt" type="text" value="李亮" name="xingming">
				<img src="/static/rt.png" alt="">
			</div>
		</li>
		<li class="pad">
			<span>生日</span>
			<div class="fr">
				<input class="font_c ipt" type="text" value="" name="birthday">
				<img src="/static/rt.png" alt="">
			</div>
		</li>

		<li class="pad site_info">
			<span>常用地址</span>
			<div class="fr ">
				<textarea class="font_c site" name="address" id="" cols="30" rows="4"></textarea>
				<img class="rt_img" src="/static/rt.png" alt="">
			</div>
			
		</li>
	</ul>
	<a class="apply_sub">确认</a>
	</form>
</div>
</template>

<script>
import {
  Current
} from "@/api/api.js"
export default {
  data () {
    return {
    }
  },
  methods:{
  },
  created:function(){
    Current({},function(res){
      
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/wechat/my.vue